<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Clonage d'une vue</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field class="mat-form-field-text">
                    <mat-label>Nom de la vue</mat-label>
                    <input matInput [formControl]="viewNameFormControl" autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field class="mat-form-field-text">
                    <input #selectControl type="text" matInput [formControl]="organizationFormControl" [matAutocomplete]="auto" />
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        [displayWith]="displayLabel"
                        (opened)="opened()"
                        (closed)="closed()"
                        class="organization-autocomplete"
                        panelWidth="fit-content">
                        @for (organization of filteredOrganizations | async; track organization) {
                            <mat-option [value]="organization">
                                {{ organization.name }}
                            </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" (click)="save()" [disabled]="!organizationFormControl.valid || !viewNameFormControl.valid">Enregistrer</button>
    </mat-card-actions>
</mat-card>
